import React, { useState, useEffect } from "react";
import SearchBar from "../components/SearchBar";
import PlayerCard from "../components/PlayerCard";
import { Link } from "react-router-dom";
import axios from "axios";

const AUTH = {
  headers: {
    Authorization: `Bearer ${process.env.REACT_APP_SUPABASE_ANON_KEY}`,
  },
};

function PlayersPage() {
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [featured, setFeatured] = useState([]);
  const [loading, setLoading] = useState(false);

  // Load all players once → pick 3 random
  useEffect(() => {
    const fetchAll = async () => {
      try {
        const res = await axios.get(
          `https://pfuzmgbswynewjxsweqd.supabase.co/functions/v1/get-players`,
          AUTH
        );
        const players = res.data || [];
        const shuffled = [...players].sort(() => 0.5 - Math.random());
        setFeatured(shuffled.slice(0, 3));
      } catch (err) {
        console.error(err);
      }
    };
    fetchAll();
  }, []);

  // Live search as user types
  useEffect(() => {
    const search = async () => {
      if (!searchTerm.trim()) {
        setSearchResults([]);
        return;
      }

      setLoading(true);
      try {
        const res = await axios.get(
          `https://pfuzmgbswynewjxsweqd.supabase.co/functions/v1/get-players?name=${searchTerm}`,
          AUTH
        );
        setSearchResults(res.data || []);
      } catch (err) {
        console.error(err);
        setSearchResults([]);
      }
      setLoading(false);
    };

    const delay = setTimeout(search, 300); // debounce
    return () => clearTimeout(delay);
  }, [searchTerm]);

  const handleSearch = (term) => {
    setSearchTerm(term);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 py-8">
      <div className="container mx-auto px-4 max-w-6xl">
        <h1 className="text-4xl font-bold text-center mb-8 text-gray-900">
          Player Search TEST, please work why
        </h1>

        <div className="mb-8">
          <SearchBar onSearch={handleSearch} />
        </div>

        {/* LIVE SEARCH RESULTS */}
        {searchResults.length > 0 && (
          <div className="mb-12 bg-white rounded-2xl shadow-lg p-6">
            <h2 className="text-xl font-bold mb-4 text-gray-800">
              Search Results ({searchResults.length})
            </h2>
            <div className="space-y-2">
              {searchResults.map((p) => (
                <Link
                  key={p.id}
                  to={`/player/${p.id}`}
                  className="block p-3 rounded-lg hover:bg-blue-50 transition"
                >
                  <div className="flex justify-between items-center">
                    <span className="font-medium text-lg">{p.name}</span>
                    <span className="text-sm text-gray-500">
                      {p.position} • {p.teams?.abbreviation || "—"}
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        )}

        {loading && (
          <div className="text-center py-8 text-gray-600">Searching...</div>
        )}

        {searchResults.length === 0 && searchTerm && !loading && (
          <div className="text-center py-8 text-gray-600">
            No results found.
          </div>
        )}

        {/* STATIC RANDOM FEATURED */}
        <div className="mt-12">
          <h2 className="text-2xl font-bold mb-6 text-center text-gray-800">
            Featured Players
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {featured.map((p) => (
              <PlayerCard key={p.id} playerId={p.id} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PlayersPage;
